import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/angularjs';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { MessagesService }          from '../messages/messages.service';
import { PodiumService }            from './podium.service';
import { PodiumSettingsModel }      from './typings/podium.settings.model';
import { SessionService }           from '../sessions/session.service';

@Component({
  selector   : 'wor-podium-settings',
  template: require('./podium.settings.component.html')
})
export class PodiumSettingsComponent {
  @Input() integrations: CompanyIntegrationsModel;
  @Input() settings    : PodiumSettingsModel;

  title : string = this.podiumService.title;

  constructor (
    private companyService  : CompanyService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    public  sessionService  : SessionService,
    private translateService: TranslateService,
    private podiumService   : PodiumService
  ) {}

  activate () : void {
    if ( !this.companyService.isSubscriptionPlan('platinum') ) {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.PLATINUM_REQUIRED'), 'error');

      return;
    }

    this.podiumService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.podiumService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  generateApiKey () : void {
    this.podiumService.generateApiKey()
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.NEW_API_KEY_GENERATED'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
